import { preparePaymentAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import { isValidOrderPointUsageRequest } from '@/common/utils/pointPolicy';
import { cloneDeep } from 'lodash';

const { order, check, carts, check_stock, status: paymentStatus, isFinish, cancel } = preparePaymentAPI;

const getPositiveCartRequests = (cart = []) =>
  cart.filter((item) => Number(item?.stock ?? 0) > 0);
const getPositivePaymentCart = (cart = []) =>
  cart.filter((item) => Number(item?.cartStock ?? 0) > 0);

export default {
  CHECK_AVAILABLE: async (
    { state, commit },
    params = {
      latitude: 0,
      longitude: 0,
      storeNo: 0,
      userNo: null,
      productNos: []
    }
  ) => {
    const { status, data } = await ServiceExec.patch(check, params);

    if (status === ServiceExec.status.OK) commit('setStore', data);
    return data;
  },
  CART: async ({ state, commit }, cartList) => {
    const request = {
      ...cartList,
      cart: getPositiveCartRequests(cartList?.cart)
    };
    const { status, data } = await ServiceExec.patch(carts, request, { notLoading: true });
    const syncedCart = Array.isArray(data) ? getPositivePaymentCart(data) : data;
    if (status === ServiceExec.status.OK) commit('setCart', syncedCart);
    return { status, data: syncedCart };
  },

  ORDER: async ({ getters, rootGetters, commit }) => {
    const params = cloneDeep(getters['getAll']);

    params.cart = getPositivePaymentCart(params.cart);
    params.store = params.storeInfo.store;
    const pointPayableAmount =
      Number(params.totalProductsPrice) +
      Number(params.deliveryFee) -
      Number(params.discountAmount) -
      Number(params.couponDiscountAmount);
    const ownedPoints = Number(rootGetters['user/getPoints']);
    if (
      !isValidOrderPointUsageRequest(
        params.pointUsageAmount,
        ownedPoints,
        pointPayableAmount,
        params.store?.isPointAvailable
      )
    )
      return false;
    const { status, data } = await ServiceExec.post(order, params);
    if (status !== ServiceExec.status.OK) return false;

    if (params.phone?.startsWith('84+')) commit('user/updateAuthPhone', params.phone, { root: true });
    const { orderNo, orderManageNo } = data;
    commit('setOrderNo', orderNo);
    commit('setOrderManageNo', orderManageNo);
    return true;
  },

  CANCEL: async ({ getters, commit }, { orderNo }) => {
    const { status, data } = await ServiceExec.delete(cancel(orderNo));
    if (status === ServiceExec.status.OK) return data;
    else return false;
  },

  PAYMENT_STATUS: async ({ commit }, no) => {
    const { status, data } = await ServiceExec.get(paymentStatus(no), {}, { notLoading: true });
    if (status !== ServiceExec.status.OK || !data) {
      return {
        paymentStatus: 'WAIT',
        terminal: false,
        success: false
      };
    }

    return data;
  },

  IS_FINISH: async ({ commit }, no) => {
    const { data } = await ServiceExec.get(isFinish(no));
    return data;
  },

  CHECK_CART_STOCK: async ({ getters, commit }) => {
    const cart = getPositivePaymentCart(getters['getCart']);
    const parsed = [...cart]
      .map((elem) => ({
        productNo: elem.productNo,
        stock: elem.cartStock
      }))
      .reduce((p, n) => {
        const idx = p.findIndex((v) => {
          if ((v?.productNo ?? -1) == n.productNo) return v;
        });

        if (idx !== -1) {
          p[idx].stock += n.stock;
          return p;
        } else return [...p, n];
      }, []);

    if (parsed.length === 0) {
      commit('setInvalidStockList', []);
      return;
    }

    const { status, data } = await ServiceExec.get(check_stock, {
      products: parsed
    });
    if (status !== ServiceExec.status.OK) return;

    commit('setInvalidStockList', data);
  }
};
